import { render } from "./MomentBox.vue?vue&type=template&id=6db8affa&scoped=true&ts=true"
import script from "./MomentBox.vue?vue&type=script&lang=ts"
export * from "./MomentBox.vue?vue&type=script&lang=ts"

import "./MomentBox.vue?vue&type=style&index=0&id=6db8affa&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db8affa"]])

export default __exports__